import Table from '../../../../../common/components/table';


export const FroumGroupsValuesComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedForumGroupsValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedForumGroupsValues}
                onEdit={handleEdit} headingName="Forum Groups Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
        </div>
    )
}
export default FroumGroupsValuesComponent;
